import React from 'react';

const SvgMenu = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 19.997 12.998"
    fill="none"
    className="Menu_svg__icon Menu_svg__icon-hamburger"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.997 3.5H0V0h19.997zm0 9.498H0v-3.5h19.997z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMenu;
